var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customProductSheetImageTable_empty"> <div class="panel"> <div class="row"> <div id="customProductSheetImageTableList"></div> </div> <div class="row"> <div id="main-col" class="col-sm-12 col-md-12"> <div id="customProductSheetImageTablePagination" style="text-align:center"></div> </div> </div> <div class="row" style="text-align:center"> <div id="customProductSheetImageTableInsert"></div> </div> </div> </div>';
}
return __p;
};
